import { Alert, Button, Stack, Text } from '@mantine/core';
import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Estado {
  erro: Error | null;
}

/** Impede que a falha de um componente apague o app inteiro (mostra a mensagem no lugar). */
export class LimiteDeErro extends Component<{ children: ReactNode }, Estado> {
  state: Estado = { erro: null };

  static getDerivedStateFromError(erro: Error): Estado {
    return { erro };
  }

  componentDidCatch(erro: Error, info: ErrorInfo) {
    console.error('Erro ao renderizar a página:', erro, info.componentStack);
  }

  render() {
    if (!this.state.erro) return this.props.children;
    return (
      <Alert color="red" title="Erro ao exibir esta página">
        <Stack gap="xs">
          <Text size="sm">{this.state.erro.message}</Text>
          <Button size="xs" variant="light" onClick={() => this.setState({ erro: null })}>
            Tentar de novo
          </Button>
        </Stack>
      </Alert>
    );
  }
}
